import WechatJSSDK from "wechat-jssdk/dist/client.umd";
import { getWechatConfig, wechatAuth, getWechatConfigBuy } from "@api/public";
import { parseQuery } from "@utils";
import cookie from "@utils/store/cookie";
import store from "@/store";
import dayjs from "dayjs";

const STATE_KEY = "wx_authorize_state";
const WX_AUTH = "wx_auth";
const BACK_URL = "login_back_url";
const LOGINTYPE = "loginType";
let instance;

export default function wechat() {
  return new Promise((resolve, reject) => {
    if (instance) {
      console.log("second load success -----");
      return resolve(instance);
    }

    getWechatConfig()
      .then(res => {

        console.log("wechat config data---shiyi");
        console.log(res.data);
        let weixinConfig = {
          // debug: true,
          appId: "",
          jsApiList: ["editAddress", "updateTimelineShareData", "updateAppMessageShareData", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "downloadVoice", "chooseImage", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getNetworkType", "openLocation", "getLocation", "hideOptionMenu", "showOptionMenu", "hideMenuItems", "showMenuItems", "hideAllNonBaseMenuItem", "showAllNonBaseMenuItem", "closeWindow", "scanQRCode", "chooseWXPay", "openProductSpecificView", "addCard", "chooseCard", "openCard"],
          nonceStr: "",
          signature: "",
          timestamp: ""
        }
        weixinConfig.appId = res.data.appId;
        weixinConfig.nonceStr = res.data.nonceStr;
        weixinConfig.signature = res.data.signature;
        weixinConfig.timestamp = res.data.timestamp;

        const _wx = WechatJSSDK(weixinConfig);
        _wx
          .initialize()
          .then(() => {
            console.log("load weixin success");
            instance = _wx.wx;
            instance.initConfig = weixinConfig;
            resolve(instance);
          })
          .catch(err => {
            console.log("load catch 1----------");
            console.log(err);
          });

      })
      .catch(err => {
        console.log("load catch 2----------");
        console.log(err);
        reject(err);
      });
});

}

export function wechatConfig() {
    cookie.set("jssdkReady", 0);
    if (instance) {
      console.log("second load success --222---");
      cookie.set("jssdkReady", 1);
      return;
    }

    getWechatConfig()
      .then(res => {

        console.log("wechat config data---shiyi--222");
        console.log(res.data);
        let weixinConfig = {
          // debug: true,
          appId: "",
          jsApiList: ["editAddress", "updateTimelineShareData", "updateAppMessageShareData", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "downloadVoice", "chooseImage", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getNetworkType", "openLocation", "getLocation", "hideOptionMenu", "showOptionMenu", "hideMenuItems", "showMenuItems", "hideAllNonBaseMenuItem", "showAllNonBaseMenuItem", "closeWindow", "scanQRCode", "chooseWXPay", "openProductSpecificView", "addCard", "chooseCard", "openCard"],
          nonceStr: "",
          signature: "",
          timestamp: ""
        }
        weixinConfig.appId = res.data.appId;
        weixinConfig.nonceStr = res.data.nonceStr;
        weixinConfig.signature = res.data.signature;
        weixinConfig.timestamp = res.data.timestamp;

        const _wx = WechatJSSDK(weixinConfig);
        _wx
          .initialize()
          .then(() => {
            console.log("load weixin 2 success");
            instance = _wx.wx;
            instance.initConfig = weixinConfig;
            cookie.set("jssdkReady", 1);
          })
          .catch(err => {
            console.log("load catch 1-----22-----");
            console.log(err);
          });

      })
      .catch(err => {
        console.log("load catch 2-----22-----");
        console.log(err);
      });

}

export function wechatConfigBuy() {
  cookie.set("jssdkReady", 0);
  if (instance) {
    console.log("second load success --222---");
    cookie.set("jssdkReady", 1);
    return;
  }

  getWechatConfigBuy()
    .then(res => {

      console.log("wechat config data---shiyi--222");
      console.log(res.data);
      let weixinConfig = {
        // debug: true,
        appId: "",
        jsApiList: ["editAddress", "updateTimelineShareData", "updateAppMessageShareData", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "startRecord", "stopRecord", "onVoiceRecordEnd", "playVoice", "pauseVoice", "stopVoice", "onVoicePlayEnd", "uploadVoice", "downloadVoice", "chooseImage", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getNetworkType", "openLocation", "getLocation", "hideOptionMenu", "showOptionMenu", "hideMenuItems", "showMenuItems", "hideAllNonBaseMenuItem", "showAllNonBaseMenuItem", "closeWindow", "scanQRCode", "chooseWXPay", "openProductSpecificView", "addCard", "chooseCard", "openCard"],
        nonceStr: "",
        signature: "",
        timestamp: ""
      }
      weixinConfig.appId = res.data.appId;
      weixinConfig.nonceStr = res.data.nonceStr;
      weixinConfig.signature = res.data.signature;
      weixinConfig.timestamp = res.data.timestamp;

      const _wx = WechatJSSDK(weixinConfig);
      _wx
        .initialize()
        .then(() => {
          console.log("load weixin 2 success");
          instance = _wx.wx;
          instance.initConfig = weixinConfig;
          cookie.set("jssdkReady", 1);
        })
        .catch(err => {
          console.log("load catch 1-----22-----");
          console.log(err);
        });

    })
    .catch(err => {
      console.log("load catch 2-----22-----");
      console.log(err);
    });

}

export function clearAuthStatus() {
  cookie.remove(WX_AUTH);
  cookie.remove(STATE_KEY);
}

export function oAuth() {
  if (cookie.has(WX_AUTH) && store.state.app.token) return;
  const { code } = parseQuery();
  if (!code) return toAuth();
}

export function auth(code) {
  return new Promise((resolve, reject) => {
    let loginType = cookie.get(LOGINTYPE);
    //if (state !== cookie.get(STATE_KEY)) return reject();
    wechatAuth(code, parseInt(cookie.get("spread")), loginType)
      .then(({ data }) => {
        const expires_time = dayjs(data.expires_time);
        store.commit("LOGIN", data.token, expires_time);
        cookie.set(WX_AUTH, code, expires_time);
        cookie.remove(STATE_KEY);
        loginType && cookie.remove("loginType");
        resolve();
      })
      .catch(reject);
  });
}

export function toAuth() {
  wechat().then(wx => {
    location.href = getAuthUrl(wx.initConfig.appId);
  });
}

function getAuthUrl(appId) {
  // const redirect_uri = encodeURIComponent(
  //   `${location.origin}/auth/` +
  //     encodeURIComponent(
  //       encodeURIComponent(
  //         cookie.has(BACK_URL)
  //           ? cookie.get(BACK_URL)
  //           : location.pathname + location.search
  //       )
  //     )
  // );
  const redirect_uri = "http://datum.lishuedu.com";

  cookie.remove(BACK_URL);
  const state = encodeURIComponent(
    ("" + Math.random()).split(".")[1] + "authorizestate"
  );
  cookie.set(STATE_KEY, state);
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`;
}

function toPromise(fn, config = {}) {
  return new Promise((resolve, reject) => {
    fn({
      ...config,
      success(res) {
        resolve(res);
      },
      fail(err) {
        reject(err);
      },
      complete(err) {
        reject(err);
      },
      cancel(err) {
        reject(err);
      }
    });
  });
}

export function pay(config) {
  console.log("pay config -------");
  console.log(config);
  console.log("timestamp -------");
  console.log(config.timestamp);
  let payConfig = {
    appId: config.appid,
    appid: config.appid,
    nonceStr: config.nonceStr,
    paySign: config.sign,
    timeStamp: config.timestamp,
    timestamp: config.timestamp,
    package: config.package,
    partnerId: config.partnerid,
    partnerid: config.partnerid,
    signType: config.signType,
    prepayId: config.prepayid,
    prepayid: config.prepayid
  };
  // let payConfig = {
  //   appId: "wx3d4cd5590cd19363",
  //   appid: "wx3d4cd5590cd19363",
  //   nonceStr: "DuyNqQGDEdgGNzCr",
  //   paySign: "A7DC5FFBF671E5C3ADF614A5902993C9",
  //   timeStamp: "1575461908",
  //   timestamp: "1575461908",
  //   package: "prepay_id=wx0420182874072343774260191463082200",
  //   signType: "MD5"
  // };

  console.log("timestamp 2 -------");
  console.log(payConfig.timeStamp);

  return toPromise(instance.chooseWXPay, payConfig);
}

export function openAddress() {
  return toPromise(instance.openAddress);
}

export function openShareAppMessage(config) {
  instance.updateAppMessageShareData(config);
  instance.onMenuShareAppMessage && instance.onMenuShareAppMessage(config);
}

export function openShareTimeline(config) {
  instance.updateTimelineShareData(config);
  instance.onMenuShareTimeline && instance.onMenuShareTimeline(config);
}

export function ready() {
  return new Promise(resolve => {
    instance.ready(() => {
      resolve();
    });
  });
}
